<template>
    <div class="vstack gap-10">
        <div class="col-12" v-if="loading">
            <div class="text-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div v-if="data && loading == false">
            <h5>{{ data.name }}</h5>
            <p class="text-sm text-muted mt-1"></p>
            <div class="vstack gap-3">
                <router-link :to="{ name: 'PermissionItemCreate', params: { id: data.id } }" v-if="globalViewOption('PermissionItemCreate')"
                    class="cursor-pointer w-100 d-flex align-items-center border bg-white text-success p-3 rounded-2">
                    <i class="bi bi-plus-circle text-lg me-3"></i>
                    <span class="text-success text-sm font-semibold">
                        <div class="ms-4">
                            <font style="vertical-align: inherit;">
                                <font style="vertical-align: inherit;">Crear permisos</font>
                            </font>
                            <span class="d-block text-sm text-muted">Permisos relacionados a
                                grupo</span>
                        </div>
                    </span>
                </router-link>
                <div v-for="(item, index) in data.items" :key="index"
                    class="w-100 row justify-content-between align-items-center border border-primary-hover text-heading p-3 rounded-2">
                    <div class="col-8 d-flex align-items-center">
                        <i :class="item.icon" class="text-lg me-3"></i>
                        <span class="text-body text-sm font-semibold">
                            <div class="ms-4">
                                <font style="vertical-align: inherit;">
                                    <font style="vertical-align: inherit;">{{ item.name }}</font>
                                </font>
                                <span class="d-block text-sm text-muted">{{ item.description }}</span>
                            </div>
                        </span>
                    </div>
                    <div class="col-auto">
                        <div class="d-flex align-items-center justify-content-between gap-6">
                            <div>
                                <span @click="UP(index, index - 1)" v-if="index > 0 && globalViewOption('PermissionItemOrder')"
                                    class="cursor-pointer text-sm text-muted text-danger-hover font-semibold">
                                    <i class="bi bi-arrow-up-short me-2"></i>
                                </span>
                                <span @click="DOWN(index, index + 1)" v-if="index < (data.items.length - 1) && globalViewOption('PermissionItemOrder')"
                                    class="cursor-pointer text-sm text-muted text-danger-hover font-semibold">
                                    <i class="bi bi-arrow-down-short me-2"></i>
                                </span>
                                <router-link :to="{ name: 'PermissionItemUpdate', params: { id: item.id } }" v-if="globalViewOption('PermissionItemUpdate')">
                                    <span class="cursor-pointer text-sm text-muted text-primary-hover font-semibold">
                                        <i class="bi bi-pencil-square me-2"></i>
                                    </span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['data', 'moveItem', 'loading'],
    methods: {
        UP: function (index, old) {
            let vue = this
            vue.moveItem(vue.data.items, index, old, '/order/permission/items')
        },
        DOWN: function (index, old) {
            let vue = this
            vue.moveItem(vue.data.items, index, old, '/order/permission/items')
        }
    }
}
</script>